import { render, staticRenderFns } from "./ItemEditor.vue?vue&type=template&id=c7761ee4&scoped=true"
import script from "./ItemEditor.vue?vue&type=script&lang=js"
export * from "./ItemEditor.vue?vue&type=script&lang=js"
import style0 from "./ItemEditor.vue?vue&type=style&index=0&id=c7761ee4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7761ee4",
  null
  
)

export default component.exports